export default __webpack_public_path__ + "static/media/G_Gelo.33f11e51.mp3";